import React from 'react';
import {
  Box,
  HStack,
  Input,
  NewContentButton,
  RadioButton,
} from '@design-system/pc';
import useSeqSearchAddressForm from './hooks/useSeqSearchAddressForm';
import { hasFieldError } from '@/utils';

const SeqSearchAddressForm = () => {
  const {
    handleOpenSearchAddressPopup,
    radioType,
    handleChangeRadio,
    handleChangeDetailAddress,
    register,
    errors,
    disabledZoneCode,
    disabledAddressDetail,
    disabledRoadNameAddress,
    disabledSearchButton,
    isShowRadioGroup,
  } = useSeqSearchAddressForm();

  return (
    <Box>
      {isShowRadioGroup && (
        <HStack space={24} height="40px">
          <RadioButton
            name="default"
            mr="24px"
            labelOptions={{
              text: '기본배송지',
              textVariant: 'body1',
            }}
            checked={radioType === 'default'}
            onChange={handleChangeRadio}
          />

          <RadioButton
            name="direct"
            labelOptions={{
              text: '직접입력',
              textVariant: 'body1',
            }}
            checked={radioType === 'direct'}
            onChange={handleChangeRadio}
          />
        </HStack>
      )}

      <HStack space={8} mb="4px" py="4px">
        <Input
          size="lg"
          placeholder="우편번호"
          flex={1}
          disabled={disabledZoneCode}
          readOnly
          {...register('site.address.zoneCode')}
        />
        <NewContentButton
          type="button"
          width={143}
          style={{ borderRadius: '0' }}
          icon={{ variant: 'ic_search', align: 'left' }}
          emphasis="low"
          size="lg"
          disabled={disabledSearchButton}
          onClick={handleOpenSearchAddressPopup}
        >
          우편번호 검색
        </NewContentButton>
      </HStack>
      <HStack mb="4px" py="4px">
        <Input
          size="lg"
          placeholder="주소 입력"
          flex={1}
          {...register('site.address.roadnameAddress')}
          disabled={disabledRoadNameAddress}
        />
      </HStack>
      <HStack py="4px">
        <Input
          size="lg"
          placeholder="상세 주소"
          flex={1}
          {...register('site.addressDetail', {
            required: {
              value: true,
              message: '',
            },
            pattern: {
              value: /^[^ㄱ-ㅎㅏ-ㅣ]{1,50}$/g,
              message: '주소를 정확히 입력해 주세요.',
            },
            onChange: handleChangeDetailAddress,
          })}
          disabled={disabledAddressDetail}
          isError={hasFieldError(errors, 'site.addressDetail')}
          errorMessage="주소를 정확히 입력해 주세요."
        />
      </HStack>
    </Box>
  );
};

SeqSearchAddressForm.displayName = 'SeqSearchAddressForm';

export default SeqSearchAddressForm;
